export type AlloyInstance = (command: string, options?: unknown) => Promise<unknown>;

declare global {
	interface Window {
		alloy?: AlloyInstance;
		__alloyMonitors?: unknown[];
	}
}

export const sendAdobeTargetView = (viewName: string) => {
	if (typeof window === 'undefined') return;

	if (typeof window.alloy !== 'function') {
		return;
	}

	try {
		return window.alloy('sendEvent', {
			renderDecisions: true,
			xdm: {
				web: {
					webPageDetails: {
						viewName,
					},
				},
			},
		});
	} catch {
		return true;
	}
};
